import { z } from 'zod'
import { PostureSchema } from './posture'
import { ACTION_ID_RE } from './ids'

/**
 * One role × state matrix cell. Required on every Screen IR row (TJ-B).
 * visibility deny → product actions must be absent (or listed only in actions_absent).
 */
export const CellSchema = z
  .object({
    role: z.string().min(1),
    state: PostureSchema,
    visibility: z.enum(['allow', 'deny']),
    actions_present: z.array(z.string().regex(ACTION_ID_RE)).default([]),
    actions_absent: z.array(z.string().regex(ACTION_ID_RE)).optional(),
  })
  .superRefine((cell, ctx) => {
    if (cell.visibility === 'deny' && cell.actions_present.length > 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'denied cell must not list product actions in actions_present',
        path: ['actions_present'],
      })
    }
    const present = new Set(cell.actions_present)
    for (const a of cell.actions_absent ?? []) {
      if (present.has(a)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `action "${a}" cannot be both present and absent`,
          path: ['actions_absent'],
        })
      }
    }
  })

export type Cell = z.infer<typeof CellSchema>
